import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { l_user } from '@fiverr-private/icons';
import { Icon } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { useBreakpoints } from '@fiverr-private/business_blocks';
import { grey_1200 } from '@fiverr-private/sass/helpers/index';
import { SafeWrapper } from '@fiverr-private/seller_pages_toolbox';
import { useLocalizationContext, DATETIME_ELEMENT_STYLES } from '../../../contexts/LocalizationContext';
import Languages from './Languages';
import SocialPresence from './SocialPresence';

import styles from './index.module.scss';
import './SocialPresence/social-icons.scss';

const T_KEY = 'freelancer_page.details';
export const Divider = () => <div className={styles.divider} />;

/** @type {import('./index').FreelancerProfile} */
const FreelancerProfile = ({ seller }) => {
    const { languages, joinedAt } = seller.user;
    const { onlinePresences, professionalPresences } = seller;

    const { dateTimeFormat } = useLocalizationContext();
    const { isMD } = useBreakpoints();

    const memberSince = dateTimeFormat(new Date(joinedAt * 1000), {
        year: DATETIME_ELEMENT_STYLES.NUMERIC,
        month: DATETIME_ELEMENT_STYLES.SHORT,
    });

    const hasPresences = !!(onlinePresences?.length || professionalPresences?.length);

    return (
        <div className={classnames(styles.container, { 'box-shadow-z1': isMD })}>
            <div className={classnames(styles.memberSince, 'flex-items-center')}>
                <Icon size={16} color={grey_1200}>
                    {l_user}
                </Icon>
                <div className={'m-l-12 tbody-5 text-semi-bold'}>
                    <I18n k={`${T_KEY}.member_since`} params={{ date: memberSince }} />
                </div>
            </div>
            {!isEmpty(languages) && (
                <>
                    <Divider />
                    <Languages languages={languages} />
                </>
            )}
            {hasPresences && (
                <>
                    <Divider />
                    <SocialPresence onlinePresences={onlinePresences} professionalPresences={professionalPresences} />
                </>
            )}
        </div>
    );
};

export default SafeWrapper(FreelancerProfile, 'FreelancerProfile');
